/**
 * Composant principal de l'application
 */

import axios from 'axios';
import { RouterProvider } from 'react-router-dom';
import { router } from './routes';
import { AppProviders } from './providers/AppProviders';
import { configureAuthModule, defaultReactConfig } from '@auth/config/authConfig';
import { useAuthStore } from '@auth/presentation/store/authStore';

// Reconnexion silencieuse via le cookie refreshToken httpOnly, executee une seule
// fois au chargement du module (contrat httpOnly v1.1 — l'access token en memoire
// ne survit jamais a un reload). Ne jamais deplacer ceci dans useAuth() : ce hook
// est consomme par ~30 composants et declencherait un bootstrap par composant monte.
void useAuthStore.getState().bootstrapAuth();

// Intercepteur axios : injecte le Bearer token depuis localStorage (modules paie utilisent axios natif)
axios.interceptors.request.use((config) => {
  try {
    const tokenRaw = localStorage.getItem('caritas_access_token');
    if (tokenRaw && !config.headers.Authorization) {
      const token = JSON.parse(tokenRaw);
      if (token) config.headers.Authorization = `Bearer ${token}`;
    }
  } catch {}
  return config;
});

// Configuration du module auth pour React Vite + Express Backend
// apiBaseUrl vide = URLs relatives → le proxy Vite redirige /api vers le backend
configureAuthModule({
  ...defaultReactConfig,
  apiBaseUrl: import.meta.env.VITE_API_URL || '',
  security: {
    ...defaultReactConfig.security,
    loginUrl: '/auth/login',
    defaultRedirectAfterLogin: '/dashboard',
  },
});

export function App() {
  return (
    <AppProviders>
      <RouterProvider router={router} />
    </AppProviders>
  );
}

export default App;
